export enum NotificationEmailType {
  //admission groups
  ADMISSION_GROUP_RESERVATION_CONFIRMATION_CUSTOMER = 'ADMISSION_GROUP_RESERVATION_CONFIRMATION_CUSTOMER',
  ADMISSION_GROUP_GUESTLIST_CONFIRMATION_CUSTOMER = 'ADMISSION_GROUP_GUESTLIST_CONFIRMATION_CUSTOMER',
  ADMISSION_GROUP_RESERVATION_CANCELLED_STAFF = 'ADMISSION_GROUP_RESERVATION_CANCELLED_STAFF',
  ADMISSION_GROUP_RESERVATION_CREATED_STAFF = 'ADMISSION_GROUP_RESERVATION_CREATED_STAFF',
  ADMISSION_GROUP_RESERVATION_REQUEST_CREATED_STAFF = 'ADMISSION_GROUP_RESERVATION_REQUEST_CREATED_STAFF',
  ADMISSION_GROUPS_SUMMARY_VENUE = 'ADMISSION_GROUPS_SUMMARY_VENUE',
  SCHEDULED_REPORT_UPCOMING_EVENT_TICKET_SUMMARY_VENUE = 'SCHEDULED_REPORT_UPCOMING_EVENT_TICKET_SUMMARY_VENUE',
  //
  CUSTOMER_CHAT_NEEDS_RESPONSE_STAFF = 'CUSTOMER_CHAT_NEEDS_RESPONSE_STAFF',
  CONFIRMATION_REQUEST_COMPLETED_STAFF = 'CONFIRMATION_REQUEST_COMPLETED_STAFF',
  CONFIRMATION_REQUEST_CUSTOMER_INVITE = 'CONFIRMATION_REQUEST_CUSTOMER_INVITE',
  DATA_EXPORT_GENERIC_COMPLETED_STAFF = 'DATA_EXPORT_GENERIC_COMPLETED_STAFF',
  DATA_EXPORT_GENERIC_FAILED_STAFF = 'DATA_EXPORT_GENERIC_FAILED_STAFF',
  EVENT_ATTRIBUTION_LINKS_STAFF = 'EVENT_ATTRIBUTION_LINKS_STAFF',
  AFFILIATE_ACTIVATED = 'AFFILIATE_ACTIVATED',
}

export enum NotificationType {
  EMAIL = 'email',
  PUSH = 'push',
  SMS = 'sms',
  IN_APP = 'in_app',
}
